import {
  staticText,
  brandSpecificStaticText,
} from '../../../utils/translations/staticText';

const TableBuilderTranslations = staticText({
  show_more: {
    _: 'Show More',
    zh: '顯示更多',
  },
  show_less: {
    _: 'Show Less',
    zh: '顯示部分',
  },
  apply: {
    _: 'Apply',
    zh: '立即申請',
  },
  product: {
    _: 'Product',
    zh: '產品',
  },
  /**
   * Identity-column header in Personal Loan mode (CMS-1921 R3). The only
   * front-end-owned column copy in a PL table — every other header comes from
   * the editor's column label.
   */
  loan: {
    _: 'Loan',
    zh: '銀行/財務公司',
  },
  /**
   * The module's loan basis (CMS-1921 R6), substituted at render. Placeholders
   * rather than a built string so a translation can order them freely — the ZH
   * copy puts the amount and the tenure in different places to the EN.
   */
  loan_basis: {
    _: 'Based on a {amount} loan over {tenure} months.',
    zh: '以貸款額 {amount}，還款期 {tenure} 個月計算。',
  },
  /**
   * Labels the second rate stacked under ANNUAL_RATE (CMS-1921 R4), which the
   * ticket specifies as the static label "EIR". No `zh`: the stacked cell is
   * SingSaver-only, and no ZH copy for it was given — a translation is the
   * ticket's to provide, not ours to borrow from another block.
   */
  eir: {
    _: 'EIR',
  },
  // Hot Reward Pick column (CMS-1687). EN in `_`, ZH-HK in `zh`.
  // The 🔥 is an emoji inside the string, not an icon-font glyph.
  hot_reward_pick_title: {
    _: '🔥 Hot Reward Pick',
    zh: '🔥 獨家獎賞',
  },
  see_full_reward: {
    _: 'See the full reward',
    zh: '查看所有獎賞',
  },
  // Trails the percentage in both markets: "25% off" / "40% 折扣" (per Figma).
  discount_off: {
    _: 'off',
    zh: '折扣',
  },
  module_all_offers: {
    _: '🔥 All Offers',
    zh: '🔥 所有優惠',
  },
  // Brand-specific: the exclusive-offers heading embeds the brand name, so the
  // default (used by SingSaver) says "SingSaver" and MoneyHero is overridden
  // below. ZH-HK only applies to MoneyHero (the sole zh market for this feature).
  module_exclusive: {
    _: 'SingSaver Exclusive Offers',
    zh: '獨家獎賞',
  },
  module_welcome: {
    _: 'Welcome Offers',
    zh: '迎新優惠',
  },
  module_tnc: {
    _: 'Terms & Conditions',
    zh: '條款及細則',
  },
  apply_now: {
    _: 'Apply Now',
    zh: '立即申請',
  },

  // Total Reward column, Personal Loan mode (CMS-1922).
  total_reward_title: {
    _: 'Total Reward',
    zh: '總獎賞價值',
  },
  // The exclusive source is named after the brand, so MoneyHero overrides it below.
  reward_source_exclusive: {
    _: 'SingSaver',
    zh: 'MoneyHero獨家',
  },
  reward_source_provider: {
    _: 'Provider',
    zh: '金融機構優惠',
  },
  reward_show_all: {
    _: 'Show All',
    zh: '查看所有獎賞',
  },

  // Reward modal, Personal Loan mode. Separate keys from `module_exclusive` /
  // `module_welcome`: R5 changes the PL copy without touching the HK CC one.
  module_pl_title: {
    _: 'Total Reward',
    zh: '總獎賞價值',
  },
  module_pl_exclusive: {
    _: 'SingSaver Exclusive Offers',
    zh: 'MoneyHero獨家獎賞',
  },
  module_pl_provider: {
    _: 'Provider Offers',
    zh: '金融機構優惠',
  },
  // `{amount}` arrives currency-prefixed and separated; `{tenure}` is a month count.
  module_pl_context: {
    _: "For a loan of {amount} over {tenure} months, you'll enjoy:",
    zh: '以貸款額 {amount}，還款期 {tenure} 個月計算，你將享有：',
  },
  module_pl_other_tiers: {
    _: 'Other loan amounts and tenures:',
    zh: '其他貸款金額及還款期：',
  },
});

// MoneyHero (HK) overrides: the exclusive-offers heading uses the MoneyHero
// brand name. ZH-HK already lives in the default `zh` slot above.
const moneyheroTranslations = staticText({
  module_exclusive: {
    _: 'MoneyHero Exclusive Offers',
    zh: '獨家獎賞',
  },
  module_pl_exclusive: {
    _: 'MoneyHero Exclusive Offers',
    zh: 'MoneyHero獨家獎賞',
  },
  reward_source_exclusive: {
    _: 'MoneyHero',
    zh: 'MoneyHero獨家',
  },
});

export const TRANSLATIONS = brandSpecificStaticText({
  _: TableBuilderTranslations,
  moneyhero: moneyheroTranslations,
});
